export const SET_RESTAURANT_LIST = "SET_RESTAURANT_LIST"
export const SET_RESTAURANT = "SET_RESTAURANT"
export const SET_RESTAURANT_ID = SET_RESTAURANT
export const SET_SELECTED_RESTAURANT = SET_RESTAURANT
export const SET_USER_CART = "SET_USER_CART"
export const CLEAR_USER_CART = "CLEAR_USER_CART"
export const SET_ORDER_TYPE = "SET_ORDER_TYPE"
export const SET_LOADING_FALSE = "SET_LOADING_FALSE"
export const SET_LOADING_TRUE = "SET_LOADING_TRUE"
export const SET_QR_SCANNED = "SET_QR_SCANNED"
export const SET_HIDE_DASHBOARD_BANNER = "SET_HIDE_DASHBOARD_BANNER"
export const CLEAR_ACTIVE_RESTAURANT = "CLEAR_ACTIVE_RESTAURANT"

export const LS_ORDER_TYPE_KEY = "orderType"

export const setOrderType = (dispatch, orderType) => {
    dispatch({ type: SET_ORDER_TYPE, payload: orderType });
}